
import numeral from 'numeral'
import creditCardType, { getTypeInfo, types as CardType } from 'credit-card-type';

export function clearNumber(value = '') {
    return value.toString().replace(/\D+/g, '')
}
export function formatParseReplaceSpace(value = '') {
    return value.replace(/\s/g, '')
}
export function formatReplaceSpecialCharacter(value=''){
    return value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');
}
export function formatParseMMYYYY(value = '') {
    var newValue = value;
    if (value) {
        var vals = value.split("/");
        var month = vals[0];
        var year = vals[1];
        if (year && year.length == 2) {
            newValue = month + "20" + year;
        }
    }
    return newValue;
}
export function formatCreditCardNumber(value) {
    if (!value) {
        return value
    }

    const clearValue = clearNumber(value);
    const issuer = getCardType(value);
    let nextValue

    switch (issuer) {
        case 'amex':
            nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
                4,
                10
            )} ${clearValue.slice(10, 15)}`
            break
        case 'dinersclub':
            nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
                4,
                10
            )} ${clearValue.slice(10, 14)}`
            break
        default:
            nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
                4,
                8
            )} ${clearValue.slice(8, 12)} ${clearValue.slice(12, 19)}`
            break
    }

    return nextValue.trim()
}

export function formatCVC(value, prevValue, allValues = {}) {
    const clearValue = clearNumber(value);
    let maxLength = getCVVLength(clearValue);
    return clearValue.slice(0, maxLength)
}

export function formatExpirationDate(value) {
    const clearValue = clearNumber(value)
    const maxLength = 4;
    if (clearValue.length >= 3) {
        return `${clearValue.slice(0, 2)}/${clearValue.slice(2, 4)}`
    }
    return clearValue;
}

export function formatUpperCase(value = '') {
    return value.toUpperCase();
}

export function formatLowerCase(value = '') {
    return value.toLowerCase();
}

export function formatToDouble(value = '') {
    // value = clearNumber(value);
    return numeral(value).format('0,0.00');
}
export function formatToDoubleNotComma(value = '') {
    // value = clearNumber(value);
    return numeral(value).format('0.00');
}


export function getCardType(value) {
    var type = null;
    if (value) {
        var ambiguousCards = creditCardType(value);
        if (ambiguousCards && ambiguousCards.length > 0)
            type = ambiguousCards[0].niceType;
    }
    return type;
}

function getCVVLength(value) {
    var ambiguousCards = creditCardType(value);
    var length = 4;
    if (ambiguousCards && ambiguousCards.length > 0)
        length = ambiguousCards[0].code.size;
    return length;
}

export function formatBooleanToArrayAndNullValue(value) {
    var values = [];
    if (value === true)
        value = "Y"
    else
        value = "";
    values.push(value);
    return values;
}

export function formatBooleanToArray(value) {
    var values = [];
    if (value === true)
        value = "Y"
    else
        value = "N";
    values.push(value);
    return values;
}

export function formatBooleanToArrayWithFalseAsEmpty(value) {
    var values = [];
    if (value === true)
        value = "Y"
    else
        value = "";
    values.push(value);
    return values;
}

export function formatTrueFalseToYesNo(value){
    if(value===true)
        value="Y"
    else
        value="N"
        return value;
}

//format to display 0,0.0
export function formatFloat(value) {
    if (!value)
        return '';
    if (value == '')
        return;
    let val = value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    return val;
}

export function parseFloat(value) {
    if (!value)
        return '';
    if (value == '')
        return;
    let val = value.toString().replace(/,/g, '');
    //val = val.toString().match(/\d*\.?\d{0,2}/);
    val = val.toString().match(/\d*\.?\d*/);
    //val = numeral(val[0]).format('0.00');
    val = val[0];
    //console.log('Parse Float: ' + value + ' to ' + val);
    return val;
}

export function parseAPIFloat(value) {
    if (!value)
        return '';
    if (value == '')
        return;
    let val = value.toString().replace(/,/g, '');
    val = val.toString().match(/\d*\.?\d{0,2}/);
    val = numeral(val[0]).format('0.00');
   // console.log('Parse Float for API: ' + value + ' to ' + val);
    return val;
}

const malayPrefix='+60 '
export function formatPhoneWithCountryCode(value,countryCode) {
    if (!value)
        return undefined;
    if (!countryCode)
        return value;
    //console.log('formatPhoneWithCountryCode value:',value)
    //console.log('formatPhoneWithCountryCode countryCode:',countryCode)
    // if (!value)
    //     return '+60 ';
    // if (value == '')
    //     return '+60 ';
    let val = clearNumber(value);
    let reg = new RegExp("^"+countryCode);
    let prefix = '+' + countryCode + ' ';
    val = val.toString().match(reg);
    //console.log('formatPhoneWithCountryCode val first reg:',val)
    if (!val)
        val = prefix + value;
    else 
         val = value.toString().replace(reg, prefix);
    //console.log('format Phone number: ' + value + ' to ' + val);
    return val;
}
export function formatMalayPhone(value) {
    return formatPhoneWithCountryCode(value,'60');
}

export function formatPhoneNoCountryCode(value, countryCode) {
    let prefix = countryCode ? countryCode: '60';
    let reg = new RegExp("^"+prefix);
    if (!value)
        return undefined;
    let val = clearNumber(value);
    if (val.toString().match(reg))
        val = value.toString().replace(reg, '');
    //console.log('clear format Phone number: ' + value + ' to ' + val);
    return val;
}
export function addCountryCodePhone(value,countryCode) {
    if (!value)
        return undefined;
    if (!countryCode)
        return value;
    let val = clearNumber(value);
    val = countryCode + val;
    //console.log('add country code Phone number: ' + value + ' to ' + val);
    return val;
}

export function parsePhoneWithCountryCode(value) {
    if (!value)
        return '';
    if (value == '')
        return;
    
    let val = clearNumber(value);
    //console.log('parse Phone number: ' + value + ' to ' + val);
    return val;
}

export function removePlus(value) {
    if (!value)
        return '';
    if (value == '')
        return value;
    
    let val = value.toString().replace(/\+/g, '');
    return val;
}
